import React, { useEffect, useState } from "react";
import { LoadingDiv, SweetAlertShow } from "../../master/Master";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Master from "../Master";
import { batchList } from "../../../api/Batch";
import { holidaysCreate } from "../../../api/Holidays";
import { useNavigate } from "react-router-dom";

export default function HolidaysAdd() {
  const [loading, setLoading] = useState(false);

  const [applicable, setApplicable] = useState("all");

  const [dateType, setDateType] = useState("single");

  const [batches, setBatches] = useState([]);

  const navigate = useNavigate();

  const getBatches = async () => {
    setLoading(true);

    try {
      const response = await batchList();

      if (response?.data?.status === true) {
        setBatches(response?.data?.data || []);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleFromSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const formData = new FormData(e.target);

      const response = await holidaysCreate(formData);

      if (response?.data?.status === true) {
        SweetAlertShow(
          "success",
          "Successfully",
          response?.data?.message || "Holiday created successfully.",
        );

        navigate("/holidays");
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBatches();
  }, []);

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />

                  <div className="col-12">
                    <div className="card">
                      {/* HEADER */}
                      <div className="card-header">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <h4 className="text-primary mb-1">
                              <i className="ri-calendar-event-line me-2" />
                              Add Holiday
                            </h4>

                            <small className="text-muted">
                              Create a single-day or multiple-day holiday
                            </small>
                          </div>

                          <button
                            type="button"
                            className="btn btn-label-secondary"
                            onClick={() => navigate("/holidays")}
                          >
                            <i className="ri-arrow-left-line me-1" />
                            Back
                          </button>
                        </div>
                      </div>

                      <div className="card-body">
                        <form onSubmit={handleFromSubmit}>
                          <div className="row g-3">
                            {/* TITLE */}
                            <div className="col-md-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="text"
                                  className="form-control input-capitalize"
                                  name="title"
                                  id="title"
                                  placeholder="Holiday Title"
                                  required
                                />

                                <label htmlFor="title">Holiday Title</label>
                              </div>
                            </div>

                            {/* TYPE */}
                            <div className="col-md-3">
                              <div className="form-floating form-floating-outline">
                                <select
                                  name="type"
                                  id="type"
                                  className="form-select"
                                  defaultValue="full"
                                  required
                                >
                                  <option value="full">Full Day</option>

                                  <option value="half">Half Day</option>
                                </select>

                                <label htmlFor="type">Holiday Type</label>
                              </div>
                            </div>

                            {/* APPLICABLE */}
                            <div className="col-md-3">
                              <div className="form-floating form-floating-outline">
                                <select
                                  name="applicable"
                                  id="applicable"
                                  className="form-select"
                                  value={applicable}
                                  onChange={(e) =>
                                    setApplicable(e.target.value)
                                  }
                                  required
                                >
                                  <option value="all">All</option>

                                  <option value="batch">Batch</option>

                                  <option value="staff">Staff</option>
                                </select>

                                <label htmlFor="applicable">
                                  Applicable To
                                </label>
                              </div>
                            </div>

                            {/* DESCRIPTION */}
                            <div className="col-12">
                              <div className="form-floating form-floating-outline">
                                <textarea
                                  name="description"
                                  id="description"
                                  className="form-control"
                                  placeholder="Description"
                                  style={{
                                    minHeight: 100,
                                  }}
                                />

                                <label htmlFor="description">Description</label>
                              </div>
                            </div>

                            {/* DATE TYPE */}
                            <div className="col-12">
                              <div className="border rounded p-3">
                                <div className="mb-3">
                                  <h6 className="mb-1">
                                    <i className="ri-calendar-line me-2 text-primary" />
                                    Holiday Date
                                  </h6>

                                  <small className="text-muted">
                                    Select one date or create holidays for a
                                    date range.
                                  </small>
                                </div>

                                <div className="row">
                                  {/* SINGLE */}
                                  <div className="col-md-3">
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="date_type"
                                        id="single_date"
                                        value="single"
                                        checked={dateType === "single"}
                                        onChange={() => setDateType("single")}
                                      />

                                      <label
                                        className="form-check-label"
                                        htmlFor="single_date"
                                      >
                                        <i className="ri-calendar-2-line me-1" />
                                        Single Date
                                      </label>
                                    </div>
                                  </div>

                                  {/* RANGE */}
                                  <div className="col-md-3">
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="date_type"
                                        id="range_date"
                                        value="range"
                                        checked={dateType === "range"}
                                        onChange={() => setDateType("range")}
                                      />

                                      <label
                                        className="form-check-label"
                                        htmlFor="range_date"
                                      >
                                        <i className="ri-calendar-schedule-line me-1" />
                                        Date Range
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* SINGLE DATE */}
                            {dateType === "single" && (
                              <div className="col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="date"
                                    className="form-control"
                                    name="date"
                                    id="date"
                                    required
                                  />

                                  <label htmlFor="date">Holiday Date</label>
                                </div>
                              </div>
                            )}

                            {/* RANGE */}
                            {dateType === "range" && (
                              <>
                                <div className="col-md-6">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      type="date"
                                      className="form-control"
                                      name="from_date"
                                      id="from_date"
                                      required
                                    />

                                    <label htmlFor="from_date">From Date</label>
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      type="date"
                                      className="form-control"
                                      name="to_date"
                                      id="to_date"
                                      required
                                    />

                                    <label htmlFor="to_date">To Date</label>
                                  </div>
                                </div>
                              </>
                            )}

                            {/* BATCH */}
                            {applicable === "batch" && (
                              <div className="col-12">
                                <div className="border rounded p-3">
                                  <div className="d-flex align-items-center mb-3">
                                    <i className="ri-group-line text-primary me-2" />

                                    <strong>Select Batches</strong>
                                  </div>

                                  <div className="row g-2">
                                    {batches?.length > 0 ? (
                                      batches.map((batch, i) => (
                                        <div
                                          className="col-md-3 col-lg-2"
                                          key={batch?.id || i}
                                        >
                                          <div className="form-check border rounded p-2">
                                            <input
                                              className="form-check-input ms-0 me-2"
                                              type="checkbox"
                                              value={batch?.id}
                                              id={`batch_${batch?.id}`}
                                              name="batch_id[]"
                                            />

                                            <label
                                              className="form-check-label"
                                              htmlFor={`batch_${batch?.id}`}
                                            >
                                              {batch?.title}
                                            </label>
                                          </div>
                                        </div>
                                      ))
                                    ) : (
                                      <div className="col-12">
                                        <div className="alert alert-warning mb-0">
                                          <i className="ri-information-line me-1" />
                                          No batches found.
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* INFO */}
                            <div className="col-12">
                              <div className="alert alert-primary d-flex align-items-start">
                                <i className="ri-information-line fs-5 me-2" />

                                <div>
                                  <strong>Date Range:</strong> If you select 10
                                  Sep to 15 Sep, the system will create holidays
                                  for every date from 10 Sep through 15 Sep.
                                </div>
                              </div>
                            </div>

                            {/* BUTTON */}
                            <div className="col-12 text-end">
                              <button
                                type="button"
                                className="btn btn-label-secondary me-2"
                                onClick={() => navigate("/holidays")}
                              >
                                <i className="ri-close-line me-1" />
                                Cancel
                              </button>

                              <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={loading}
                              >
                                <i className="ri-save-line me-1" />
                                Save Holiday
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
